import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { UserModel } from "shared/models";
import { ICONS } from "shared/constants";
import { UiIcon } from 'shared/uikit';
import { LeagueEnum } from "shared/enums";

import './styles.scss';

type PropsType = {
    user: UserModel,
}

export const PProfileLeague = observer(({ user }: PropsType) => {
    const placeLeague = (league: string) => {
        let name = "";
        let place = 0;
        let color = "#ffffff";
        let icon = "";

        const widgetsLeagueRating = user.tinetsWidgets?.find(item => item.typeId === "league_rating");

        if (widgetsLeagueRating && (league === "plan" || league === "sales")) {
            const curentPlace = widgetsLeagueRating?.[league]?.items?.find(item => item.isCurrent);

            const enumLeague = LeagueEnum.items.find(item => item.id === curentPlace?.league);

            if (enumLeague && curentPlace) {
                icon = curentPlace.isLeagueLeader ? enumLeague.iconOne : enumLeague.iconAnother;
                color = enumLeague.color ?? "#ffffff";
                name = enumLeague.name ?? "";
                place = curentPlace.place ?? 0;
            }
        }

        return { name, place, color, icon }
    }

    return (
        <div className="p-user-section p-user-section--32pt">
            <div className="p-user-section__title">Достижения в лиге первых</div>

            <div className="p-user-league">
                <div className="p-user-league__group">
                    <div className="p-user-league__item">
                        <div className="p-user-league__name p-user-section__subtitle">Место в рейтинге «План»</div>

                        <div className="p-user-league__place">
                            <div className="p-user-league__place-value">
                                <UiIcon
                                    size={35}
                                    icon={ICONS[placeLeague("plan").icon as keyof typeof ICONS]}
                                />
                                <span style={{color: placeLeague("plan").color}}>{placeLeague("plan").place}</span>
                            </div>
                            <div className="p-user-league__place-name">{placeLeague("plan").name}</div>
                        </div>
                    </div>

                    <div className="p-user-league__item">
                        <div className="p-user-league__name p-user-section__subtitle">Место в рейтинге «Продажи»</div>

                        <div className="p-user-league__place">
                            <div className="p-user-league__place-value">
                                <UiIcon
                                    size={35}
                                    icon={ICONS[placeLeague("sales").icon as keyof typeof ICONS]}
                                />
                                <span style={{color: placeLeague("sales").color}}>{placeLeague("sales").place}</span>
                            </div>
                            <div className="p-user-league__place-name">{placeLeague("sales").name}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
